import TransferFundCard from './TransferFundCard'

// The tab's empty state, on the same card chrome as the rest of the screen
// and as the home page's zero-fund card.
//
// The «انتقال صندوق به همیان» button had no handler until pwa#104; see
// TransferFundCard.
export default function NoFunds() {
    return (
        <div className="px-3 pt-4 pb-6 flex flex-col gap-3">
            <div className="bg-white border border-divider rounded-card p-5 text-center">
                <div className="w-10 h-10 mx-auto rounded-full bg-brand-soft flex items-center justify-center">
                    <svg
                        className="w-5 h-5 text-green-1"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        strokeWidth={2}
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M12 4v16m8-8H4"
                        />
                    </svg>
                </div>
                <p className="mt-3 text-base font-bold text-heading">
                    شما عضو صندوقی نیستید
                </p>
                <p className="mt-2 text-sm text-text-secondary leading-relaxed">
                    با دکمه‌ی + صندوق خودتان را بسازید، یا از مدیر صندوق بخواهید
                    لینک دعوت را برایتان بفرستد.
                </p>
            </div>

            <TransferFundCard source="funds_empty" />
        </div>
    )
}
